import { quickAddReferenceRegistry } from './quickAddReferenceRegistry';

/**
 * Resolve whether the current user may quick-add a reference entity.
 * Uses permission codes first; isSuperAdmin always allows.
 *
 * @param {string} entity
 * @param {{ hasPermission: (code: string) => boolean, isSuperAdmin: boolean|import('vue').Ref<boolean> }} auth
 * @returns {boolean}
 */
export function canQuickAddEntity(entity, { hasPermission, isSuperAdmin } = {}) {
  const superAdmin =
    typeof isSuperAdmin === 'object' && isSuperAdmin != null && 'value' in isSuperAdmin
      ? !!isSuperAdmin.value
      : !!isSuperAdmin;

  if (superAdmin) return true;

  const config = quickAddReferenceRegistry[entity];
  if (!config || typeof hasPermission !== 'function') return false;

  if (config.permission && hasPermission(config.permission)) return true;
  if (config.scopedPermission && hasPermission(config.scopedPermission)) return true;

  return false;
}

/**
 * Build a quick-add policy map for common org entities.
 * @param {{ hasPermission: Function, isSuperAdmin: boolean|import('vue').Ref<boolean> }} auth
 */
export function buildQuickAddPolicy(auth) {
  return {
    department: canQuickAddEntity('department', auth),
    position: canQuickAddEntity('position', auth),
    // Grades are managed in Settings only — no inline quick-add on employee/profile forms.
    grade: false,
    location: canQuickAddEntity('location', auth),
    terminal: canQuickAddEntity('terminal', auth),
    subDepartment: canQuickAddEntity('subDepartment', auth),
    team: canQuickAddEntity('team', auth),
  };
}
